import { render, staticRenderFns } from "./customDashboardLogins.vue?vue&type=template&id=75c5d945"
import script from "./customDashboardLogins.vue?vue&type=script&lang=js"
export * from "./customDashboardLogins.vue?vue&type=script&lang=js"
import style0 from "./customDashboardLogins.vue?vue&type=style&index=0&id=75c5d945&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports